import { Clock, ShieldCheck, Users } from "lucide-react";
import { FIND_RIDE_COLORS } from "../constants/findRide.constants";
import { tFindRide } from "../locales/FindRideTranslations";

const TRUST_ITEMS = [
  {
    key: "safe",
    Icon: ShieldCheck,
    titleKey: "trustSafeTitle",
    bodyKey: "trustSafeBody",
  },
  {
    key: "quick",
    Icon: Clock,
    titleKey: "trustQuickTitle",
    bodyKey: "trustQuickBody",
  },
  {
    key: "save",
    Icon: Users,
    titleKey: "trustSaveTitle",
    bodyKey: "trustSaveBody",
  },
] as const;

export function FindRideTrustStrip() {
  return (
    <ul className="grid grid-cols-3 gap-2 sm:gap-4">
      {TRUST_ITEMS.map(({ key, Icon, titleKey, bodyKey }) => (
        <li key={key} className="flex min-w-0 flex-col items-center text-center">
          <span
            className="mb-1.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/90 shadow-sm sm:mb-2 sm:h-10 sm:w-10"
            style={{ color: FIND_RIDE_COLORS.pageGreen }}
          >
            <Icon className="h-4 w-4 sm:h-5 sm:w-5" aria-hidden />
          </span>
          <p
            className="text-[11px] font-bold leading-tight sm:text-sm"
            style={{ color: FIND_RIDE_COLORS.pageGreen }}
          >
            {tFindRide(titleKey)}
          </p>
          <p className="mt-1 hidden max-w-[12rem] text-xs leading-snug text-gray-600 sm:block">
            {tFindRide(bodyKey)}
          </p>
        </li>
      ))}
    </ul>
  );
}
